import {
  TransactionOrderId,
  TransactionCountryFlag,
  TransactionCardNumber,
  TransactionChargedAmount,
  TransactionCreatedAt,
  TransactionStatus,
} from '@widgets/tables/cells/transactions';
import { useTransactionDetailsDialog } from '@utils/dialogs-hooks';

export default function TransactionMobile({ row }) {
  const { openTransactionDetailsDialog } = useTransactionDetailsDialog();
  return (
    <div
      className="tableMobile__list-item"
      onClick={() => openTransactionDetailsDialog(row)}
    >
      <div className="transactionBankCell transactionMobile">
        <div>
          <div className="transactionBankCell__icon">
            <TransactionCountryFlag row={row} />
            <TransactionCardNumber row={row} />
          </div>
          <TransactionOrderId row={row} />
        </div>
        <div className="transactionMobile__right">
          <TransactionChargedAmount row={row} />
          <TransactionCreatedAt row={row} />
          <TransactionStatus row={row} />
        </div>
      </div>
    </div>
  );
}
